module.exports = __webpack_public_path__ + "img/cg.5ac865a4.png";